import { render } from "./ChangePasswordForm.vue?vue&type=template&id=12a65ca0&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=12a65ca0&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a65ca0"]])

export default __exports__